/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// document.addEventListener('click', function(e) {
//   const btn = e.target.closest('[data-action="toggle-collapsible"]');
//   if (!btn) return;
//   // only run below 999px
//   if (window.innerWidth > 999) return;
//   btn.classList.toggle('active');
// });

// document.addEventListener('click', function (e) {
//   const btn = e.target.closest('[data-action="toggle-collapsible"]');
//   if (!btn) return;
//   const id = btn.getAttribute('aria-controls');
//   const content = document.getElementById(id);
//   const isOpen = btn.getAttribute('aria-expanded') === 'true';
//   btn.setAttribute('aria-expanded', !isOpen);
//   content.setAttribute('aria-hidden', isOpen);
//   if (!isOpen) {
//     content.style.height = content.scrollHeight + "px";
//   } else {
//     content.style.height = "0px";
//   }
// });

// document.querySelectorAll('[data-action="toggle-collapsible"]').forEach(button => {
//   button.addEventListener('click', () => {
    
//     const content = document.getElementById(button.getAttribute('aria-controls'));

//     const isOpen = button.getAttribute('aria-expanded') === 'true';

//     // Toggle
//     button.setAttribute('aria-expanded', !isOpen);
//     content.classList.toggle('is-open', !isOpen);
//     content.setAttribute('aria-hidden', isOpen);
//   });
// });


document.querySelectorAll('[data-action="toggle-collapsible"]').forEach(button => {
  button.addEventListener('click', () => {
    
    const content = document.getElementById(button.getAttribute('aria-controls'));

    const isOpen = button.getAttribute('aria-expanded') === 'true';

    // Toggle
    button.setAttribute('aria-expanded', !isOpen);
    content.classList.toggle('is-open', !isOpen);
    content.setAttribute('aria-hidden', isOpen);
  });
});

// WSP live price hydration for blog/landing-page product boxes (owner 2026-10-20: "shopify native cta" with price).
// Only touches .wsp-commercial[data-mode="BUY"] boxes (never [data-mode="QUOTE"] - those stay price-free by design,
// same rule as the on-site quote gate). Reads the box's own "View full details"/"Buy Now" link (already present,
// unedited) to get the real product handle, then calls Shopify's own public /products/<handle>.js endpoint for the
// live price - no page text or URL is touched, this only fills in what the writer already left as a placeholder.
(function () {
  function fmt(cents, currency) {
    var amt = cents / 100;
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format(amt);
    } catch (e) {
      return '$' + amt.toFixed(2);
    }
  }
  function hydrate(box) {
    if (box.getAttribute('data-wsp-hydrated')) return;
    box.setAttribute('data-wsp-hydrated', '1');
    var variantId = box.getAttribute('data-variant-id');
    var link = box.querySelector('a[href*="/products/"]');
    if (!link) return;
    var href = link.getAttribute('href').split('?')[0].split('#')[0];
    var handle = href.split('/products/')[1];
    if (!handle) return;
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants || !p.variants.length) return;
        var v = null;
        if (variantId) {
          v = p.variants.filter(function (x) { return String(x.id) === String(variantId); })[0];
        }
        if (!v) v = p.variants[0];
        if (!v || v.available === false) return;
        var priceEl = box.querySelector('.wsp-price');
        if (!priceEl) {
          priceEl = document.createElement('p');
          priceEl.className = 'wsp-price';
          priceEl.style.cssText = 'margin:.35rem 0;font-size:1.15rem;font-weight:700';
          var buy = box.querySelector('.wsp-cta-buy');
          if (buy && buy.parentNode === box) box.insertBefore(priceEl, buy);
          else box.appendChild(priceEl);
        }
        priceEl.setAttribute('data-wsp-live', '1');
        priceEl.textContent = fmt(v.price, (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD');
      })
      .catch(function () {});
  }
  function run() {
    document.querySelectorAll('.wsp-commercial[data-mode="BUY"]').forEach(hydrate);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
